import de from 'element-plus/es/locale/lang/de';

/**
 * Element Plus' German language pack leaves the InputNumber controls untranslated
 * ("decrease number"/"increase number"). They carry no visible text, so these aria-labels
 * are all a screen reader finds — and there is no prop to set them per call site.
 */
export const locale = {
  ...de,
  el: {
    ...de.el,
    inputNumber: {
      decrease: 'Wert verringern',
      increase: 'Wert erhöhen',
    },
  },
};
